import { render, staticRenderFns } from "./PackageWarehousing.vue?vue&type=template&id=57623c41&scoped=true&"
import script from "./PackageWarehousing_.js?vue&type=script&lang=js&"
export * from "./PackageWarehousing_.js?vue&type=script&lang=js&"
import style0 from "./PackageWarehousing.vue?vue&type=style&index=0&id=57623c41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57623c41",
  null
  
)

export default component.exports